import { useLanguage } from '@/contexts/language-context';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { fillTemplate, formatMoney } from '@/lib/utils';

interface Props {
  note: string;
  onNoteChange: (note: string) => void;
  selectedCount: number;
  selectedTotal: number;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export function SubmitBar({
  note,
  onNoteChange,
  selectedCount,
  selectedTotal,
  onSubmit,
  isSubmitting,
}: Props) {
  const { t } = useLanguage();

  return (
    <div className="sticky bottom-4 bg-card border rounded-xl p-4 flex flex-col sm:flex-row sm:items-center gap-3 shadow-sm">
      <Input
        type="text"
        value={note}
        onChange={(e) => onNoteChange(e.target.value)}
        placeholder={t.payrollNotePlaceholder}
        className="flex-1 h-9"
        data-testid="payroll-note-input"
      />
      <div className="flex items-center gap-3 shrink-0">
        <span className="text-sm font-semibold whitespace-nowrap">
          {fillTemplate(t.payrollSelectedTotal, {
            count: selectedCount,
            amount: formatMoney(selectedTotal),
          })}
        </span>
        <Button
          size="sm"
          disabled={selectedCount === 0 || isSubmitting}
          onClick={onSubmit}
          data-testid="payroll-mark-paid"
        >
          {t.payrollMarkAsPaid}
        </Button>
      </div>
    </div>
  );
}
